/** Must match backend `authCookies.csrfCookieName` in config.default.ts */
export const CSRF_COOKIE_NAME = 'saas_platform_csrf';
